// import external dependencies
import 'jquery';
import 'moment';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import quiz from './routes/quiz';
import satisfactionPoll from './routes/satisfaction-poll';
import cart from './routes/cart';
import lpfjournal from './routes/lpf-journal';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Exam page
  quiz,
  // Satisfaction poll page
  satisfactionPoll,
  // Cart page
  cart,
  // LPF Journal page
  lpfjournal,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// resources/assets/scripts/main.js